import { Injectable } from "@angular/core";
import { BaseMapperWithSerializer } from "../../base.mapper";
import { PutUserLastTokenModel } from "../../../models/apis/system/user/put-user-last-token.model";
import { PutUserLastTokenHttp } from "../../../http-models/systems/user/put-user-last-token.http";
import { StatusResponseModel } from "../../../models/apis/status-response.model";
import { StatusResponseHttp } from "../../../http-models/status-response.http";


@Injectable({
    providedIn: 'root',
})

export class PutUserLastTokenMapper implements BaseMapperWithSerializer
<PutUserLastTokenModel, PutUserLastTokenHttp,
    StatusResponseModel, StatusResponseHttp> {

    convertTo(model: PutUserLastTokenModel): PutUserLastTokenHttp {
        const http: PutUserLastTokenHttp = {
            lastToken: model.lastToken
        };
        return http;
    }

    convertFrom(http: StatusResponseHttp): StatusResponseModel {
        return {...http} as StatusResponseModel;
    }

}
